import {THEME} from '@wandb/weave/common/css/color.styles';
import * as globals from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

export const IconButton = styled.div<{
  small?: boolean;
  disabled?: boolean;
  size?: number;
}>`
  width: ${p => p.size ?? 24}px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: ${p => p.size ?? 18}px;
  }
  padding: 3px;
  border-radius: 3px;

  color: ${THEME.textTertiary};
  ${p =>
    p.disabled &&
    css`
      color: light-dark(var(--moon-300), var(--moon-700));
      cursor: not-allowed;
      pointer-events: none;
    `}
  &:hover {
    ${p =>
      !p.disabled &&
      css`
        color: ${THEME.textPrimary};
        background-color: light-dark(
          ${globals.hexToRGB(globals.OBLIVION, 0.05)},
          color-mix(in srgb, var(--white) 8%, transparent)
        );
      `}
  }

  &:not(:last-child) {
    margin-right: 4px;
  }
`;
